// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2ab871ec","239":"8eb081f9","455":"6cedfdae"}[chunkId] + ".chunk.js";
};